import * as React from "react";
import { z } from "zod";
import { templateKeys, nodeTypes } from "../config/nodes";

const typeEnum = z.enum(nodeTypes);


const templateEnum = z.enum(templateKeys);

export const appSchema = z.object({
  id: z.string().optional(),
  type: typeEnum.optional(),
  name: z.string().nonempty("App name should not be empty"),
  key: z.string().optional(),
  template: z.string().optional(),
  generated: z.boolean().optional(),
  config: z.record(z.any()).default({}),
  requiredEnvs: z.array(z.string()).optional(),
});

export type appConfigs = {
  auth?: boolean;
  db?: boolean;
  providers?: string[];
};

export type AppContextType = z.infer<typeof appSchema>;

export type AppMap = {
  [key: string]: AppContextType;
};

export const AppContext = React.createContext<AppContextType>({
  name: "",
  config: {},
  key: undefined,
  template: undefined,
  type: undefined,
  id: "",
});
